import React, { useState, useEffect, useRef } from 'react';
import { Element, Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import { FlipWords } from "../../components/flip-words";

const Homepage = () => {
  const words = ["People", "Ideas", "Reviews"];
  const [showVideo, setShowVideo] = useState(false);


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowVideo(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (audioRef.current) {
        audioRef.current.play().then(() => {
          setIsPlaying(true);
        }).catch((error) => {
          console.error("Failed to play audio:", error);
        });
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <Element 
      name="component1" 
      className="relative h-screen overflow-hidden flex">
      <RouterLink
        to="/search"
        className="absolute top-8 left-8 z-20 px-6 py-3 bg-custom-blue text-custom-white text-1_5xl rounded-l-full rounded-r-full hover:bg-custom-white hover:text-custom-blue hover:border-2 hover:border-custom-blue transition-colors duration-200"
      >
        Try it now
      </RouterLink>
      <div>
      <audio
        ref={audioRef}
        src="/my_audio_2.mp3"
        muted={false}
        style={{ display: 'none' }}
      />
      </div>
      <button
        onClick={handlePlayPause}
        className="z-10 top-4 right-4 fixed p-2 flex items-center justify-center w-8 h-8 bg-custom-blue text-white rounded-full shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          <img
            src={isPlaying ? "/volume-up-xxl.png" : "/mute-xxl.png"}
          />
          {isPlaying ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              
            </svg>
          )}
      </button>
      <div className="grid grid-cols-12 gap-4">
        <div className="lg:col-span-1 sm:col-span-0 border p-2 flex items-center justify-center"/>
        <div className="lg:col-span-7 sm:col-span-12 border flex p-7 justify-center">
          <div className="text-custom-white w-full top-0 relative z-10 flex flex-col items-left justify-left text-left p-4 space-y-4 font-sans">
            <div className="lg:text-8xl sm:text-8xl leading-extra-extra-tight">
              Travel Better, Forever
            </div>
            <div className="lg:text-4xl sm:text-3xl leading-tight">
              Find<FlipWords words={words}/><br/>that matter to you
            </div>
            <div className='lg:block sm:hidden'>
            <ScrollLink 
              to="component2" 
              smooth={true} 
              duration={500} 
              className="w-32 h-10 flex text-1xl 
                      hover:text-custom-blue 
                      hover:outline-custom-blue justify-center 
                      text-custom-white 
                      bg-custom-blue 
                      hover:bg-custom-white 
                      hover:border-2 
                    border-custom-blue 
                      focus:ring-4 focus:outline-none
                    focus:ring-blue-300 font-medium rounded-l-full rounded-r-full text-sm px-5 py-2.5 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 cursor-pointer font-sans "
            >
               Know more
            </ScrollLink>
            </div>
          </div>
        </div>
        <div className="lg:col-span-3 iphone13:col-span-0 flex items-center justify-center"/>
        <div className="lg:col-span-1 iphone13:col-span-0 flex items-center justify-center"/>
      </div>
      
      {!showVideo ? (
        <img 
          src="https://plus.unsplash.com/premium_photo-1676393904171-738ff11eceaa?q=80&w=2072&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
          alt="Image" 
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
      ) : (
        <video 
          src="https://videos.pexels.com/video-files/13326453/13326453-uhd_3840_2160_30fps.mp4"
          autoPlay
          loop
          muted
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
      )}
    </Element>
  );
};

export default Homepage;
